import React, { lazy, useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { paths } from 'routes/paths';
import { initPublicAnalytics } from '@services/amplitude.service';
import { useQrSession } from 'hooks/use-qr-session';

// Qr Code Menu
const QrCodeHomepage = lazy(() => import('@pages/qr-code-menu/qr-code-homepage'));
const QrCodeMenuPage = lazy(() => import('@pages/qr-code-menu/qr-code-menu-page'));

/**
 * Wrapper component to initialize public analytics context for QR code menu routes
 */
function QrCodeAnalyticsWrapper() {
  const { clubId, tableId } = useParams();

  useEffect(() => {
    if (clubId) {
      initPublicAnalytics(clubId, tableId);
    }
  }, [clubId, tableId]);

  // Initialize minimal session tracking (bounce + session_end only)
  useQrSession(clubId || '', tableId);

  return <Outlet />;
}

export const qrCodeRoutes = [
  {
    element: <QrCodeAnalyticsWrapper />,
    children: [
      { path: paths.qrcodeMenu.root, element: <QrCodeHomepage /> },
      { path: paths.qrcodeMenu.menu, element: <QrCodeMenuPage /> },
    ],
  },
];
